import { render, staticRenderFns } from "./NewsManager.vue?vue&type=template&id=7df655dc&scoped=true&"
import script from "./NewsManager.vue?vue&type=script&lang=js&"
export * from "./NewsManager.vue?vue&type=script&lang=js&"
import style0 from "./NewsManager.vue?vue&type=style&index=0&id=7df655dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df655dc",
  null
  
)

export default component.exports